import { jsx as _jsx, Fragment as _Fragment } from "preact/jsx-runtime";
import { Icon, List, ListItem, Wrapper, } from './styles';
function PaymentIcons(props) {
    const { icons } = props;
    return (_jsx(Wrapper, { className: "basket__payment-icons", children: _jsx(List, { children: icons.map((icon) => {
                const iconEl = (_jsx(Icon, { children: _jsx("img", { src: icon.src, alt: icon.alt ?? '' }) }));
                const pictureWrapper = icon.href
                    ? _jsx("a", { href: icon.href, target: icon.target ? icon.target : '_self', children: iconEl })
                    : _jsx(_Fragment, { children: iconEl });
                return _jsx(ListItem, { children: pictureWrapper });
            }) }) }));
}
export default PaymentIcons;
